export const PositionClass = {
   manualPositions: 'Manual Positions',
   tradingSystems: 'Trading Systems',
   archivedPositions: 'Archived Positions'
};
